import React, { FunctionComponent } from 'react';
// import { useTheme } from '@mui/material/styles';
// import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

import SentimentSatisfiedIcon from '@mui/icons-material/SentimentSatisfied';

import { Base } from './Base';

type Props = {
  activeValue: number;
  onClick: (value: number) => void;
};

export const FaceHappy: FunctionComponent<Props> = ({activeValue, onClick}) => {
  // const theme = useTheme();
  // const navigate = useNavigate();
  const {t, i18n} = useTranslation(['translations']);

  return (<Base
    label={t("client.models.move_moments.feeling_happy", "Licht tevreden")}
    value={2}
    activeValue={activeValue}
    onClick={onClick}
    Icon={SentimentSatisfiedIcon}
  />);
}